/* =========================================================================
   RELOAD — toast.js
   theme.js appends a plain .toast to #toastStack. This file watches the
   stack, hides each plain toast and shows a card in its place. For "added to
   bag" it reads the bag and shows the piece that went in: photo, label,
   name, size and price.
   ========================================================================= */
(function () {
  'use strict';

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var CHECK = '<svg viewBox="0 0 12 12" aria-hidden="true"><path d="M2 6.4 4.8 9 10 3"/></svg>';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function money(cents) {
    var n = (cents || 0) / 100;
    var whole = Math.round(n) === n;
    var txt;
    try {
      txt = n.toLocaleString('tr-TR', { minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: 2 });
    } catch (e) { txt = n.toFixed(whole ? 0 : 2); }
    return txt + ' TL';
  }

  function sized(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  var host = null;
  function getHost() {
    if (host) return host;
    host = document.createElement('div');
    host.className = 'rt-host';
    host.setAttribute('aria-live', 'polite');
    document.body.appendChild(host);
    return host;
  }

  function mount(card, life) {
    var h = getHost();
    card.style.setProperty('--rt-life', life + 'ms');
    h.appendChild(card);
    while (h.children.length > 2) h.removeChild(h.firstChild);
    requestAnimationFrame(function () { requestAnimationFrame(function () { card.classList.add('in'); }); });

    var left = life, started = Date.now(), timer = null;
    function close() {
      clearTimeout(timer);
      card.classList.add('out');
      setTimeout(function () { if (card.parentNode) card.parentNode.removeChild(card); }, 260);
    }
    function run() { started = Date.now(); timer = setTimeout(close, left); }
    function hold() { clearTimeout(timer); left -= Date.now() - started; }
    card.addEventListener('mouseenter', hold);
    card.addEventListener('mouseleave', run);
    card.addEventListener('focusin', hold);
    card.addEventListener('focusout', run);
    var x = card.querySelector('.rt-x');
    if (x) x.addEventListener('click', close);
    run();
  }

  function head(msg, extra) {
    return '<div class="rt-head"><span class="rt-mark">' + CHECK + '</span>' +
      '<span class="rt-msg">' + esc(msg) + '</span>' + (extra || '') +
      '<button type="button" class="rt-x" aria-label="Close">&#215;</button></div>';
  }

  function plain(msg, warn) {
    var c = document.createElement('div');
    c.className = 'rt' + (warn ? ' rt--warn' : '');
    c.setAttribute('role', warn ? 'alert' : 'status');
    c.innerHTML = head(msg).replace(warn ? CHECK : '\u0000', '') + '<i class="rt-bar"></i>';
    mount(c, warn ? 4800 : 3200);
  }

  function added(msg, href, label) {
    fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var it = cart && cart.items && cart.items[0];
        if (!it) return plain(msg);
        var size = it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '';
        var count = cart.item_count === 1 ? '1 piece' : cart.item_count + ' pieces';
        var c = document.createElement('div');
        c.className = 'rt rt--item';
        c.setAttribute('role', 'status');
        c.innerHTML =
          head(msg, '<span class="rt-count">' + esc(count) + '</span>') +
          '<div class="rt-body">' +
            '<a class="rt-img" href="' + esc(it.url || '#') + '" tabindex="-1">' +
              (it.image ? '<img src="' + esc(sized(it.image, 200)) + '" alt="">' : '') +
            '</a>' +
            '<div class="rt-info">' +
              (it.vendor ? '<div class="rt-brand">' + esc(it.vendor) + '</div>' : '') +
              '<div class="rt-title">' + esc(it.product_title) + '</div>' +
              '<div class="rt-meta"><span class="rt-size">' + (size ? 'Size ' + esc(size) : '&nbsp;') + '</span>' +
              '<span>' + esc(money(it.final_price)) + '</span></div>' +
            '</div>' +
          '</div>' +
          '<a class="rt-cta" href="' + esc(href || ROOT + 'cart') + '">' + esc(label || 'View bag') + ' <span>&#8594;</span></a>' +
          '<i class="rt-bar"></i>';
        mount(c, 5200);
      })
      .catch(function () { plain(msg); });
  }

  function take(el) {
    if (!el.classList || !el.classList.contains('toast') || el.classList.contains('rt-src')) return;
    el.classList.add('rt-src');
    var msgEl = el.querySelector('span');
    var msg = msgEl ? msgEl.textContent : el.textContent;
    var link = el.querySelector('a');
    var warn = el.classList.contains('warn');
    if (!warn && link && /\/cart\/?$/.test(link.getAttribute('href') || '')) {
      added(msg, link.getAttribute('href'), link.textContent);
    } else {
      plain(msg, warn);
    }
  }

  function start() {
    var stack = document.getElementById('toastStack');
    if (!stack) return;
    Array.prototype.forEach.call(stack.children, take);
    new MutationObserver(function (list) {
      list.forEach(function (m) { Array.prototype.forEach.call(m.addedNodes, take); });
    }).observe(stack, { childList: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
